// extracted by mini-css-extract-plugin
module.exports = {"Sidenav":"Sidenav_Sidenav__3IxC3","sidenavOpen":"Sidenav_sidenavOpen__3S_06","SidenavShadow":"Sidenav_SidenavShadow__12cZw","SidenavLogo":"Sidenav_SidenavLogo__w27DW"};